import React from 'react';
import styles from './style.scoped.css';

export default function Error404() {
  return (
    <div className={styles['main-page']}>
      <div className={styles.container}>
        <div>
          <img
            alt=""
            src="https://storage.googleapis.com/fin-map-images-public-stage/assets/page-not-found/img/illus-page-not-found.svg"
          />
        </div>
        <div>
          <h1>Halaman Tidak Ditemukan</h1>
          <p>
            Tidak dapat menampilkan halaman yang Anda cari. Silakan periksa
            kembali alamat situs yang Anda masukkan.
          </p>
        </div>
      </div>
    </div>
  );
}
